// Bottom Navigation component for Sunlight Grounds Care Client Portal
import { NavLink } from 'react-router-dom';

// Tab icons as inline SVGs - Updated colors
const icons = {
  overview: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#1B3A5C' : '#6B7F8E'} strokeWidth="1.8">
      <rect x="3" y="3" width="8" height="8" rx="1.5" />
      <rect x="13" y="3" width="8" height="8" rx="1.5" />
      <rect x="3" y="13" width="8" height="8" rx="1.5" />
      <rect x="13" y="13" width="8" height="8" rx="1.5" />
    </svg>
  ),
  schedule: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#1B3A5C' : '#6B7F8E'} strokeWidth="1.8">
      <line x1="4" y1="7" x2="20" y2="7" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="4" y1="17" x2="20" y2="17" />
    </svg>
  ),
  delivery: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#1B3A5C' : '#6B7F8E'} strokeWidth="1.8">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <rect x="6" y="6" width="5" height="5" rx="1" />
      <rect x="13" y="6" width="5" height="5" rx="1" />
      <rect x="6" y="13" width="5" height="5" rx="1" />
      <rect x="13" y="13" width="5" height="5" rx="1" />
    </svg>
  ),
  comms: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#1B3A5C' : '#6B7F8E'} strokeWidth="1.8">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  account: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#1B3A5C' : '#6B7F8E'} strokeWidth="1.8">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
    </svg>
  )
};

export default function BottomNav({ allowedTabs = [] }) {
  // Define all possible tabs — supports both landscape_ prefixed and standard tab IDs
  const allTabs = [
    { ids: ['landscape_overview', 'overview'], path: '/overview', label: 'Overview', icon: 'overview' },
    { ids: ['landscape_schedule', 'schedule'], path: '/schedule', label: 'Schedule', icon: 'schedule' },
    { ids: ['landscape_photos', 'photos'], path: '/delivery', label: 'Delivery', icon: 'delivery' },
    { ids: ['communication', 'communications', 'messages'], path: '/comms', label: 'Comms', icon: 'comms' },
    { ids: ['account', 'payments'], path: '/account', label: 'Account', icon: 'account', alwaysShow: true }
  ];

  // Filter tabs based on permissions (account always shows, show all if no restrictions)
  const visibleTabs = allowedTabs.length === 0
    ? allTabs
    : allTabs.filter(tab => tab.alwaysShow || tab.ids.some(id => allowedTabs.includes(id)));

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-black/10 shadow-lg"
      style={{ 
        zIndex: 99999,
        paddingTop: '8px',
        paddingBottom: 'max(12px, env(safe-area-inset-bottom))'
      }}
      data-testid="bottom-nav"
    >
      <div className="flex justify-around items-center max-w-2xl mx-auto px-2">
        {visibleTabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) => `
              flex flex-col items-center gap-1 min-w-[56px] py-1 relative
              transition-colors duration-200
            `}
            data-testid={`nav-${tab.icon}`}
          >
            {({ isActive }) => (
              <>
                {/* Active indicator - gold bar */}
                {isActive && (
                  <div 
                    className="absolute -top-2 left-1/2 -translate-x-1/2 w-6 h-[3px] bg-gold rounded-full"
                    data-testid={`nav-${tab.icon}-indicator`}
                  />
                )}
                {/* Icon */}
                <div className="h-6 flex items-center justify-center">
                  {icons[tab.icon](isActive)}
                </div>
                {/* Label */}
                <span className={`text-[10px] font-dm ${isActive ? 'text-navy font-semibold' : 'text-slate'}`}>
                  {tab.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
